<template>
  <div>
    <div style="width: 100%;height:350px" :id="id"></div>
  </div>
</template>
<script>
// 按需引入 ECharts 图表和组件
// 引入 ECharts 主模块
var echarts = require('echarts/lib/echarts');
// 引入柱状图
require('echarts/lib/chart/bar');
// 引入提示框和标题组件
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');

export default {
  components: {},
  props: {},
  data() {
    return {
      id: 'id' + Math.floor(Math.random() * 1000),
      chart: null
    }
  },

  created() {},
  mounted() {
    this.init()
  },
  beforeDestroy() {
    window.onresize = null
  },
  methods: {
    init() {
      // 基于准备好的dom，初始化echarts实例
      this.chart = echarts.init(document.getElementById(this.id))
    },
    resize() {
      this.chart.resize()
    },
    setData(series, xAxisData, title) {
      // this.renderData(series, title)
      this.bar(series, xAxisData, title)
    },
    renderData: function(series, xAxisData, title) {
      /*// 普通柱状图
      let commonBarSeries = [{
        name: '提交订单',
        type: 'bar',
        barMaxWidth: 30,
        data: [10, 52, 200, 334, 390, 330, 220]
      }, {
        name: '完成订单',
        type: 'bar',
        barMaxWidth: 30,
        data: [390, 330, 220, 10, 52, 200, 334]
      }]

      // 堆叠柱状图
      let stackBarSeries = [{
        name: '三包',
        type: 'bar',
        stack: '堆',
        barMaxWidth: 30,
        data: [10, 52, 200, 334, 390, 330, 220]
      }, {
        name: '自费',
        type: 'bar',
        stack: '堆',
        barMaxWidth: 30,
        data: [390, 330, 220, 10, 52, 200, 334]
      }]*/
      this.bar(series, xAxisData, title)
    },
    bar: function(series, xAxisData, title) {
      let option = {
        color: ['#5396ff', '#62c564', '#f2cf31', '#3f4780', '#8a54e4'],
        title: {
          text: title,
          textAlign: 'left',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: '0%',
          right: '0%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [{
          type: 'category',
          data: xAxisData, // ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          axisTick: {
            alignWithLabel: true
          },
          show: true,
          nameTextStyle: {
            color: 'rgba(0, 0, 0, 1)'
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(0, 0, 0, 0.3)'
            }
          },
          // x刻度
          axisTick: {
            show: false
          }
        }],
        yAxis: [{
          type: 'value',
          show: false
        }],
        series: series
      };
      this.chart.setOption(option)
    },
  }
}

</script>
